import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { SearchBar } from '@/components/SearchBar';
import { MapGrid } from '@/components/MapGrid';
import { api } from '@/lib/api';

export function HomePage() {
  const navigate = useNavigate();

  // Fetch random maps
  const {
    data: randomMaps,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['random-maps'],
    queryFn: ({ signal }) => api.getRandomMaps(12, { signal }),
  });

  const handleSearch = (query: string) => {
    navigate(`/search?q=${encodeURIComponent(query)}`);
  };

  return (
    <div className="space-y-12">
      {/* Hero Section */}
      <div className="text-center space-y-6 py-12">
        <h1 className="text-6xl font-display font-bold text-stone-100 tracking-wide">
          Dyson Logos Map Archive
        </h1>
        <p className="text-2xl text-stone-300 max-w-2xl mx-auto">
          Browse and search incredible maps by Dyson Logos
        </p>
        <div className="mt-8">
          <SearchBar onSearch={handleSearch} />
        </div>
      </div>

      {/* Random Maps */}
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h2 className="text-4xl font-display font-bold text-stone-100 tracking-wide">Random Maps</h2>
          <button
            onClick={() => navigate('/maps')}
            className="text-gold-400 hover:text-gold-300 font-medium transition-colors"
          >
            View All →
          </button>
        </div>

        {isError && (
          <div className="rounded-md border border-blood-700 bg-blood-900/40 p-4 text-blood-300">
            {error instanceof Error ? error.message : 'Unable to load maps right now. Please try again later.'}
          </div>
        )}

        {!isError && <MapGrid maps={randomMaps || []} isLoading={isLoading} />}
      </div>
    </div>
  );
}
